import { cleanRut, formatRutWithDots } from '@utils/rut.utils';

const RutFormatter = {
    onInput: (event: Event) => {
        const input = event.target as HTMLInputElement;
        const rawValue = input.value.toLowerCase();
        
        // Limpiar y limitar a 9 caracteres
        let cleanValue = cleanRut(rawValue);
        if (cleanValue.length > 9) {
            cleanValue = cleanValue.slice(0, 9);
        }
        
        // Si hay al menos 2 caracteres, formatear con la utilidad
        if (cleanValue.length > 1) {
            input.value = formatRutWithDots(cleanValue);
        } else {
            input.value = cleanValue;
        }
    },
    onKeyDown: (event: KeyboardEvent) => {
        // Permitir teclas de control y navegación
        if (
            event.key === 'Backspace' || 
            event.key === 'Delete' ||
            event.key === 'Tab' ||
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowRight' ||
            event.key === 'Home' ||
            event.key === 'End' ||
            event.ctrlKey || // Permitir Ctrl+V, Ctrl+C, Ctrl+X, etc.
            event.metaKey    // Permitir Cmd+V, Cmd+C, Cmd+X en Mac
        ) {
            return;
        }

        // Permitir solo números y 'k' para teclas normales
        const allowed = /[0-9kK]/;
        if (!allowed.test(event.key)) {
            event.preventDefault();
        }
    }
}

export default RutFormatter;